var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-digid"},[_c('CcModestButton',{attrs:{"label":_vm.$t('components.verificationcode.resendverificationcode'),"margin-top":true},on:{"select":_vm.resendVerificationCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }